<template>
  <div>
    <section class="section-md section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-150">
        <span>&nbsp;</span>
        <div class="row text-center justify-content-center">
          <div class="col-lg-6">
            <h2 class="display-3 text-white" style="margin-top: 2.5rem">
              Software Development
            </h2>
            <h4 class="text-white">
              Digital products, i.e. applications, systems and integrations.
            </h4>
          </div>
        </div>
        <div class="text-center">
          <base-button type="primary" class="mt-4 bg-gradient-primary">
            <a href="#/contact-us" class="text-white"> Get in touch! </a>
          </base-button>
        </div>
      </div>
    </section>
    <section class="section section-sm">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-1">
            <img src="img/29938.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-6 order-md-2">
            <div class="pr-md-5">
              <h3>Software engineering</h3>
              <p style="text-align: justify">
                Do you have any idea for an IT product? Realize it with us! We use modern
                software engineering techniques.
              </p>
              <p style="text-align: justify">
                Thanks to a well-defined work organization, this field allows us to create
                large and complex software to obtain a working product that meets the
                customer's requirements.
              </p>
              <ul class="list-unstyled">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon icon-shape bg-gradient-primary icon-sm shadow rounded-circle text-white mr-3"
                      ><i class="ni ni-settings-gear-65"></i
                    ></span>
                    <h5 class="mb-0">Software development</h5>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon icon-shape bg-gradient-primary icon-sm shadow rounded-circle text-white mr-3"
                      ><i class="ni ni-settings-gear-65"></i
                    ></span>
                    <h5 class="mb-0">Integrations</h5>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon icon-shape bg-gradient-primary icon-sm shadow rounded-circle text-white mr-3"
                      ><i class="ni ni-settings-gear-65"></i
                    ></span>
                    <h5 class="mb-0">Maintenance and refactoring</h5>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon icon-shape bg-gradient-primary icon-sm shadow rounded-circle text-white mr-3"
                      ><i class="ni ni-settings-gear-65"></i
                    ></span>
                    <h5 class="mb-0">Support of software and cloud services</h5>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon icon-shape bg-gradient-primary icon-sm shadow rounded-circle text-white mr-3"
                      ><i class="ni ni-settings-gear-65"></i
                    ></span>
                    <h5 class="mb-0">
                      Developers and teams matched to the technologies you need
                    </h5>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-secondary section section-sm">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <div class="card bg-default shadow border-0">
              <img
                class="card-img-top"
                data-src="img/theme/img-1-1200x1000.jpg"
                src="img/17266.jpg"
                lazy="loaded"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-4 font-weight-bold text-white">
                  AI solutions based on the GPT-3 engine
                </h4>
                <p class="text-italic text-white">
                  Machine learning will allow you to make even better use of neural
                  networks to grow your business. We will design innovative and modern IT
                  solutions customized to your company's needs.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <h3>Developing solutions based on AI</h3>
              <p style="text-align: justify">
                Our company specializes in developing software to support business
                processes in companies. The API we use - OpenAI - can be applied to
                virtually any task that involves understanding or generating natural
                language or code.
              </p>
              <p style="text-align: justify">
                We offer a range of models with different levels of power, suitable for
                tasks and the ability to tune your custom models. These models can be used
                for everything from content generation to semantic search and
                classification.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-sm section-shaped my-0 overflow-hidden">
      <div class="shape"></div>
      <div class="container py-0">
        <div class="row-grid align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon
                name="ni ni-caps-small"
                size="md"
                class="bg-gradient-primary"
                color="white"
                shadow
                rounded
              ></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3 text-primary">Software engineering</h4>
            </div>
          </div>
          <div class="col-md-11">
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-satisfied"
                    gradient="primary"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">
                    Software development according to customer specifications
                  </h5>
                  <p style="text-align: justify">
                    Today, software development and operation are all about meeting the
                    increasing needs of software users for the frequent addition of
                    innovative new features, as well as uninterrupted availability and
                    high performance.
                  </p>
                  <p style="text-align: justify">
                    Constantly consulting architectural and design assumptions, and
                    responding to changing market conditions, we will program a working
                    system according to your guidelines.
                  </p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-delivery-fast"
                    gradient="primary"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">Integration with existing IT systems</h5>
                  <p style="text-align: justify">
                    We provide integration of information systems to create a synergistic
                    and secure environment. We implement modern system management
                    standards.
                  </p>
                  <p style="text-align: justify">
                    We ensure operational reliability, data integrity, efficient
                    information exchange, and a structured work environment.
                  </p>
                  <div class="row">
                    <div class="col">
                      <p class="text-primary">
                        <b>We will perform the software integration in several stages:</b>
                      </p>
                      <div class="row">
                        <div class="col">
                          <p>1. Analysis of your needs and requirements</p>
                          <p>2. Planning</p>
                        </div>
                        <div class="col">
                          <p>3. Design</p>
                          <p>4. Implementation</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-bulb-61"
                    gradient="primary"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">
                    Maintenance/refactoring and develop existing solutions
                  </h5>
                  <p style="text-align: justify">
                    Meeting the changing demands of the market, recognizing trends, and
                    seizing them - are our daily challenges when designing new products.
                    Flexibility and speed are qualities we especially pride ourselves on.
                    In addition to code development, we are involved in refactoring and
                    repairing existing code.
                  </p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-settings"
                    gradient="primary"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">
                    Support of software and cloud services
                  </h5>
                  <p style="text-align: justify">
                    We offer flexible IT services, tailored to each client. With us, you
                    will reduce costs, benefit from the experience and knowledge of
                    specialists, improve liquidity, gain access to the latest
                    technologies, and increase the efficiency of your business.
                  </p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-books"
                    gradient="primary"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">
                    Developers and teams matched to the technologies you need
                  </h5>
                  <p style="text-align: justify">
                    In our projects, we mostly specialize in JavaScript and PHP but also
                    C# or C++. We use cloud services, mainly AWS but also Azure and Google
                    Cloud. We build and support the management of dedicated teams of all
                    sizes. We provide clients with self-organizing teams and individual
                    specialists or consultants. We employ a wide range of IT
                    professionals, including architects, business analysts, project
                    managers, software engineers, testers and experts in Business
                    Intelligence and Machine Learning.
                  </p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import AWS from "aws-sdk";
import "dotenv/config";
export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      message: "",
      name: "",
      email: "",
    };
  },
  methods: {
    scrollToElement(options) {
      const transcriptionSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden"
      )[0];
      if (transcriptionSection) {
        transcriptionSection.scrollIntoView(options);
      }
    },
    scrollToElement1(options1) {
      const matcherSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden matcher"
      )[0];
      if (matcherSection) {
        matcherSection.scrollIntoView(options1);
      }
    },
    scrollToElement2(options2) {
      const teamSection = this.$el.getElementsByClassName("section section-sm TEAM")[0];
      if (teamSection) {
        teamSection.scrollIntoView(options2);
      }
    },
    scrollToElement3(options3) {
      const teamSection = this.$el.getElementsByClassName(
        "section section-sm Technologies"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options3);
      }
    },
    scrollToProducts(options4) {
      const teamSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden PRODUCTS"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options4);
      }
    },
  },
};
</script>
